import React from 'react'
import Papa from 'papaparse';
import CSVUploader from './CSVUploader'
import Header from '@components/Comman/Header'
import { useNavigate } from 'react-router-dom'
import { ArrowRightOutlined, DownloadOutlined } from '@ant-design/icons'
import { Button, Empty, Tabs } from 'antd'
import TabPane from 'antd/es/tabs/TabPane'
import UploadList from './UploadList'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux';
import { uploadReferrerAction } from '../../actions/refer';
import { updateReferrerFailedCSVList, updateReferrerSuccessCSVList } from '@store/Business/business';

const UploadCsvReferrer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { referrerCSVList, referrerFailedCSVList} = useSelector((state:any) => state.Business);
    const { isLoading } = useSelector((state:any) => state?.General);


    const handleUploadReferrer = () => {
        let csvList = Papa.unparse(referrerCSVList, {
            header: true, // Set header to false to not include headers in the CSV
        });

        // Create a Blob from the CSV string
        const file = new Blob([csvList], { type: 'text/csv;charset=utf-8;' });

        // Create a FormData object to send the file
        let formData = new FormData();
        formData.append('file', file, 'referrer.csv'); // Specify a filename for the Blob

        dispatch(
            uploadReferrerAction(formData, (resp: any) => {
                if (resp) {
                    navigate('/my-referrers');
                    dispatch(updateReferrerSuccessCSVList([]))
                    dispatch(updateReferrerFailedCSVList([]))
                }
            })
        );
    }

  
    const handleDownloadReferrer = () => {
      const csv = Papa.unparse(referrerFailedCSVList, {
        header: true, // Set header to false to not include headers in the CSV
      });
  
      // Create a blob and download the CSV file
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'non-validated-referrer.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // ************* handle download template ************* //
    const handleDownloadTemplate = () => {
        let templateData = [
            {
                // "business_name": "XYZ",
                "firstName": "AAA",
                "lastName": "BBB",
                "email": "abc@yopmail.com",
                "mobile": "xxxxxxxxxx"
            }
        ]
        const csv = Papa.unparse(templateData, {
            header: true, // Set header to false to not include headers in the CSV
          });
      
          // Create a blob and download the CSV file
          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', 'referrerTemplate.csv');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    };

    return (
        <div>
            <Header pagTitle="Upload bulk referrer" />
            <div className='contentBody'>
                <div className="bodycard">
                    <div className="bodycardheading d-flex csv-header">
                        <div>
                            <div className="mobileView buttonsvgs" onClick={() => navigate(-1)}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                >
                                    <rect
                                        x="0.4"
                                        y="1.18168"
                                        width="23.2"
                                        height="23.2"
                                        rx="11.6"
                                        stroke="#F47523"
                                        strokeWidth="0.8"
                                    />
                                    <path
                                        d="M14 8.78168L10 12.7817L14 16.7817"
                                        stroke="#F47523"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                            Upload Referrer
                        </div>
                        <div>
                            <button className='btn btn-outline-primary' onClick={() => navigate(-1)} type='button'> Back </button>
                        </div>
                    </div>
                    <div style={{textAlign: 'center'}}>
                        <h1>Upload CSV File</h1>
                        <div className='d-flex' style={{ justifyContent: 'center', marginBottom: '15px'}}>
                            <div style={{ marginRight: '10px'}}>
                                <button className='btn btn-primary' onClick={() => handleDownloadTemplate()} type='button'> Download Template <DownloadOutlined /></button>
                            </div>
                            <div>
                                <CSVUploader />
                            </div>
                        </div>

                        {(referrerCSVList?.length || referrerFailedCSVList?.length) ? <>
                            <Tabs defaultActiveKey="1" className="custom-tabs">
                                <TabPane tab="Validated Referrer" key="1">
                                    <div style={{ textAlign: 'left' }}>
                                        <strong>Note: </strong> These are the validated referrers list which will be uploaded in our system once click on send invite button below.
                                    </div>
                                    <UploadList data={referrerCSVList} />
                                    <div className="col-lg-12 mt-15">
                                        <div className="text-end btn-groups-Forms">
                                            <Button loading={isLoading} className="btn btn-primary" type='primary' onClick={() => handleUploadReferrer()}>
                                                {isLoading ? 'Wait sending ...' : 'Send Invite'} <ArrowRightOutlined />
                                            </Button>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane tab="Non-validated Referrer" key="2">
                                    <div style={{ textAlign: 'left' }}>
                                        <strong>Note: </strong>These are the non-validated referrers list which won't be uploaded in our system you can download these by clicking on below button and after correction you can re-upload it.
                                    </div>
                                    <UploadList data={referrerFailedCSVList} />
                                    <div className="col-lg-12 mt-15">
                                        <div className="text-end btn-groups-Forms">
                                            <Button className="btn btn-primary" type='primary' onClick={() => handleDownloadReferrer()}>
                                                Download <DownloadOutlined />
                                            </Button>
                                        </div>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </>
                        :
                        <div style={{ textAlign: 'center' }}>
                            <Empty description="No File uploaded!" />
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadCsvReferrer